import React, { useId } from 'react';
import clsx from 'clsx';

import { FormItem } from '@/stories/components/Form/FormItem/FormItem';
import { FieldProps } from '@/stories/components/Form/Input/Input';
import labelStyles from '@/stories/components/Form/FormItem/label.module.css';
import input from '@/stories/components/Form/Input/input.module.css';
import checkbox from './checkbox.module.css';

export type CheckboxProps = React.ComponentProps<'input'> & Omit<FieldProps, "label"> & {
  label?: string | React.ReactElement,
}

export const Checkbox = ({label, id, name, helpText, errorText, required = false, variant, ...props}: CheckboxProps) => {
  const {style, ...inputProps} = props
  const generatedId = useId()

  return (
    <FormItem id={id || generatedId} className={clsx(input.item, input.inline)} required={required} helpText={helpText} errorText={errorText} style={style}>
      <label htmlFor={id || generatedId} className={clsx(checkbox.checkbox, labelStyles.label, labelStyles.smallLabel, variant && checkbox[variant])}>
        <input type='checkbox' id={id || generatedId} name={name} {...inputProps}/>
        <span className={checkbox.label}>{label}</span>
      </label>
    </FormItem>
  )
};
